"use client";

import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { ErrorCaptcha } from "./components/ErrorCaptcha";
import { LoginForm } from "./components/LoginForm";

export default function LoginPage() {
   const siteKey = process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY;
   if (!siteKey) {
      return <ErrorCaptcha />;
   }

   return (
      <GoogleReCaptchaProvider
         reCaptchaKey={siteKey}
         scriptProps={{ appendTo: "head", async: true, defer: true }}
      >
         <LoginForm />
      </GoogleReCaptchaProvider>
   );
}
